import React, { Component } from "react";
import { connect } from "react-redux";
import { Field } from "redux-form";
import $ from "jquery";
import { Row } from "react-foundation";

import Tick from "components/Tick";
import Image from "components/Image";
import { getAdditionalTypes, updatePreviousSelection } from "actions";
import Loading from "components/Loading";
import InputError from "../../components/InputError";
import ThemeButton from "../../components/ThemeButton";
import SeparatingLine from "../../components/SeparatingLine";
import FormHeader from "../../components/FormHeader";
import SlickSlider from "../../components/SlickSlider";

class SelectType extends Component {
    renderImage(value, index) {
        return (
            <div key={index}>
                <div className="slick-slide-image-container">
                    <Tick />
                    <Image src={value.externalImageUrl} alt="" className="slick-slide-image" />
                </div>
                <p className={"slick-slide-title"}>{value.name}</p>
                <p className={"slick-slide-subtitle show"}>{value.notes}</p>
            </div>
        );
    }

    render() {
        let { additional, input, meta } = this.props;

        if ($.isEmptyObject(additional)) {
            return <Loading />;
        }
        return (
            <div>
                <Row isColumn>
                    <SlickSlider
                        values={additional}
                        selectedId={input.value}
                        onDisplay={this.renderImage.bind(this)}
                        onChange={id => input.onChange(id)}
                    />
                </Row>
                <InputError metas={meta} />
            </div>
        );
    }
}

class AdditionalForm extends Component {
    componentWillMount() {
        this.props.getAdditionalTypes();
    }

    onSubmit(values) {
        let additionalTypeId = values.additionalTypeId;

        this.props.updatePreviousSelection({
            AdditionalTypeId: additionalTypeId
        });

        this.props.onSubmit(values);
    } 
    

    render() {
        return (
            <form className="AdditionalForm" onSubmit={this.props.handleSubmit(this.onSubmit.bind(this))}>
                <FormHeader title={"Pick a product"} subtitle={""} />
                <SeparatingLine />
                
                    <Field name="additionalTypeId" component={SelectType} additional={this.props.additional} />
                <div className="button-panel">
                    <SeparatingLine />
                    <ThemeButton className="next">Next</ThemeButton>
                </div>
            </form>
        );
    }
}

const mapStateToProps = state => {
    return {
        additional: state.Additional.Types
    };
};

export default connect(mapStateToProps, { getAdditionalTypes, updatePreviousSelection })(AdditionalForm);



// WEBPACK FOOTER //
// ./src/containers/AdditionalForm/AdditionalForm.js